var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorrectionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9998 19.3C15.0998 19.3 19.2998 15.1 19.2998 10C19.2998 4.90005 15.0998 0.70005 9.99981 0.70005C4.89981 0.700049 0.699807 4.90005 0.699807 10C0.699807 15.1 4.89981 19.3 9.9998 19.3ZM9.09981 5.40005L10.9998 5.40005L10.9998 11L9.09981 11L9.09981 5.40005ZM9.09981 12.8L10.9998 12.8L10.9998 14.7L9.09981 14.7L9.09981 12.8Z",
    fill: "#FFBDC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99941 14.7L10.8994 14.7L10.8994 12.8L8.99941 12.8L8.99941 14.7Z",
    fill: "#D6002A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99941 10.8999L10.8994 10.8999L10.8994 5.2999L8.99941 5.2999L8.99941 10.8999Z",
    fill: "#D6002A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectionIcon);
export default __webpack_public_path__ + "static/media/correction-icon.9a1b72f8a372728545cf59ef3797f618.svg";
export { ForwardRef as ReactComponent };